<template>
  <v-form @submit.prevent="request">
    <div class="register-top">
      <div>
        <h2 class="mb-6">{{ $t('register.login.title') }}</h2>
        <p v-if="isSafari">
          Certaines versions de Safari ne permettent pas la connexion. En cas de
          problème, merci d'essayer avec un autre navigateur
        </p>
        <v-text-field
          v-model="code"
          :label="$t('register.login.code')"
          :error-messages="error"
          @input="error = ''"
          class="mb-6"
        ></v-text-field>
      </div>
    </div>
    <div class="register-bottom">
      <register-base-button
        gradient="linear-gradient(90deg, #5A46C7 0%, #208DC5 100%)"
      >
        {{ $t('register.login.button') }}
      </register-base-button>
      <br />
      <router-link :to="{ name: 'Request' }" class="register-link">
        {{ $t('register.login.lost_code') }}
      </router-link>
    </div>
  </v-form>
</template>

<script>
import RegisterBaseButton from '@/components/RegisterBaseButton'

export default {
  data() {
    return {
      code: '',
      error: ''
    }
  },
  computed: {
    isSafari() {
      return this.$browserDetect.isSafari
    }
  },
  methods: {
    request() {
      this.$store
        .dispatch('auth/request', this.code.toUpperCase())
        .then(() => {
          this.$router.push({ name: 'Welcome' })
        })
        .catch(() => {
          this.error = this.$t('register.login.incorrect_code')
        })
    }
  },
  components: {
    RegisterBaseButton
  }
}
</script>
